export const WORK_ORDERS_STATUS_ENDPOINT = 'winter-service/work-orders/status'

export const WORK_ORDERS_STATUS_TRANSLATION_NAMESPACE = 'road-maintenance/winter_service2/work_orders/status'

// The period the whole dashboard is scoped to, sent to the backend as `period`.
export const STATUS_PERIOD = {
  today: 'today',
  last7Days: 'last_7_days',
  last30Days: 'last_30_days'
}

/**
 * Reserved status colours, reused from what the app already paints these states
 * with (theme tokens + the shared status indicator). They are never assigned as
 * "series colours" - every meter and tile carries its own text label and value, so
 * the state is readable without relying on the hue.
 */
export const STATUS_COLORS = {
  good: '#65AD45',
  warning: '#E8BA4E',
  serious: '#E47B26',
  critical: '#EF4444',
  // Not a status at all - the count it borders is informational, so it gets the
  // neutral border the design shows rather than a hue that would read as an alert.
  neutral: '#D1D5DB'
}

// The background each warning tile is filled with, paired with the border above.
export const STATUS_TINTS = {
  critical: '#FEF2F2',
  warning: '#FEFCE8',
  neutral: '#FFFFFF'
}

export const METER_TRACK_COLOR = '#E5E7EB'
